<template>
  <div class="tr-test game-tr-test-boolean">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div
      class="question-block"
      :class="[{ 'overflow-with-image': objectImageExist(imageData) }]"
      :style="getStyle(imageData)"
    >
      <div
        class="element-container"
        :class="[{ block: inputStatus(elementIndex) === 'correct' }]"
        v-for="(element, elementIndex) in questionsList"
        :key="'element_' + elementIndex"
        :id="'element_' + elementIndex"
      >
        <div class="question-container inner-element-container">
          <div class="question-text" v-html="element.question"></div>
        </div>
        <div class="answer-container inner-element-container">
          <!-- true status -->
          <div class="answer-item" @click="resetCheckStatus">
            <div class="">
              <label class="label-container">
                <div class="text-container">
                  {{ element.trueValue || trueValue }}
                </div>
                <input
                  type="radio"
                  :name="'element_' + elementIndex"
                  :value="String(!!element.correct)"
                  v-model="selected['element_' + elementIndex]"
                />
                <span
                  class="checkmark"
                  :class="[
                    { correct: inputStatus(elementIndex) === 'correct' },
                    { incorrect: inputStatus(elementIndex) === 'incorrect' },
                  ]"
                >
                </span>
              </label>
            </div>
          </div>
          <!-- false status -->
          <div class="answer-item" @click="resetCheckStatus">
            <div class="">
              <label class="label-container">
                <div class="text-container">
                  {{ element.falseValue || falseValue }}
                </div>

                <input
                  type="radio"
                  :name="'element_' + elementIndex"
                  :value="String(!!!element.correct)"
                  v-model="selected['element_' + elementIndex]"
                />
                <span
                  class="checkmark"
                  :class="[
                    { correct: inputStatus(elementIndex) === 'correct' },
                    { incorrect: inputStatus(elementIndex) === 'incorrect' },
                  ]"
                >
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtilsV2';
import defaultMixin from '../../mixins/defaultMixinV2';
export default {
  name: 'tr-test-boolean-v2',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin],
  data() {
    return {
      // baseQuestionsList: _.cloneDeep( this.startGameConfig.items ),
      questonShuffle: this.startGameConfig.shuffle,
      imageData: {},
      selected: {},
      trueValue: 'prawda',
      falseValue: 'fałsz',
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.questionsList = this.processQuestionsList();
      // let data = this.processQuestionsList();
      _.each(_.cloneDeep(this.questionsList), (question, questionIndex) => {
        this.selected = Object.assign({}, this.selected, {
          ['element_' + questionIndex]: '',
        });
      });
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getStyle(item) {
      let height;
      /** @type {Number} margin-bottom:10px; in main-image-container */
      let imageMarginBottom = 10;
      if (item.height) {
        /** 795 is height available scen */
        height = 795 - item.height - imageMarginBottom;
        if (!_.isNumber(height) || height < 0) {
          height = undefined;
        }
      }
      return _.merge({ height: [height, 'px'].join('') }, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return {
        // 'position': 'absolute',
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      };
    },
    inputStatus(index) {
      let element = 'element_' + index;
      let status = 'unset';
      if (this.$store.getters.gameCheckSwitch && this.selected[element] == 'true') {
        status = 'correct';
      } else if (this.$store.getters.gameCheckSwitch) {
        status = 'incorrect';
      }
      if (
        document.querySelector(['#element_', index].join('')) &&
        document.querySelector(['#element_', index].join('')).classList.contains('block')
      ) {
        status = 'correct';
      }
      return status;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      /** @type {Boolean} set gameCheckSwitch to false - remove statys icons */
      this.gameCheckSwitch = false;
      _.each(this.selected, (item, key, collection) => {
        collection[key] = '';
        document.querySelector(['#', key].join('')) &&
          document.querySelector(['#', key].join('')).classList.remove('block');
      });
      this.init();
    },
    checkGameAction() {
      let status = _.reduce(
        this.selected,
        (result, value, key) => {
          let temVal = null;
          if (value == 'true') {
            temVal = result && true;
          } else {
            temVal = false;
          }
          return temVal;
        },
        true
      );
      // console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          // console.log('item', item);
        });
      }
      return status;
    },
    processQuestionsList() {
      let newQuestionList = [];
      let selectedItem;
      if (this.startGameConfig.pick && this.startGameConfig.items) {
        selectedItem = _.sample(_.cloneDeep(this.startGameConfig.items));
      } else {
        selectedItem = this.startGameConfig;
      }
      // // console.log( 'selectedItem', selectedItem );
      if (selectedItem.imageData) {
        this.imageData = selectedItem.imageData;
      } else if (this.startGameConfig.mainImage) {
        this.imageData = _.cloneDeep(this.startGameConfig.mainImage);
      }
      if (selectedItem.pick) {
        selectedItem.questionsList = _.sampleSize(
          selectedItem.shuffle
            ? _.shuffle(_.cloneDeep(selectedItem.questionsList))
            : _.cloneDeep(selectedItem.questionsList),
          selectedItem.pick
        );
      } else {
        selectedItem.questionsList = selectedItem.shuffle
          ? _.shuffle(_.cloneDeep(selectedItem.questionsList))
          : _.cloneDeep(selectedItem.questionsList);
      }
      // this.questionsList = (selectedItem.shuffle) ? _.shuffle(this.questionsList) : this.questionsList;
      _.each(_.cloneDeep(selectedItem.questionsList), (item, index) => {
        if (item.items && item.pick) {
          item = _.sampleSize(_.cloneDeep(item.items), item.pick)[0];
        }
        let question = item.question;
        let correct = item.correct;
        let vertical = item.vertical;
        newQuestionList.push({ question, correct, vertical });
      });
      this.questionsList = this.shuffle ? _.shuffle(newQuestionList) : newQuestionList;
      return this.questionsList;
    },
  },
  // computed: {
  //   processedQuestionsList() {
  //     return this.processQuestionsList();
  //   },
  // },
};
</script>

<style lang="scss" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$elementWidth: 1853px;
$elementHeight: 153px;
$fontSize: 28px;
.game-tr-test-boolean {
  position: relative;
  top: 160px;
  left: 11px;
  display: block;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  // height: 865px;
  height: 795px;
  width: 1906px;
  // padding: 160px 56px 127px 11px;
  box-sizing: border-box;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  // overflow-y: scroll;
  font-size: $fontSize;
  // height: 100%;
  .block {
    pointer-events: none;
  }
  // .overflow-with-image {
  //     height: 35% !important;
  // }
  .question-block {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    .element-container {
      position: relative;
      display: flex;
      width: $elementWidth;
      height: $elementHeight;
      border-radius: 20px;
      border: 3px solid $backgroundControlPanelColor;
      margin-bottom: 20px;
      .inner-element-container {
        display: flex;
        // position: absolute;
        height: 100%;
      }
      .question-container {
        width: 1478px;
        // background-color: rgba(227, 230, 123, 0.29);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-right: 3px solid $backgroundControlPanelColor;
        .question-text {
          text-align: left;
          // line-height: 28px;
          // text-align: left;
          // padding-top: 28px;
          padding-left: 35px;
          // padding-right: 35px;
        }
      }
      .answer-container {
        width: 375px;
        height: 100%;

        // background-color: rgba(6, 45, 172, 0.36);
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        .answer-item {
          display: flex;
          min-width: 22%;
          justify-content: flex-start;
          align-items: center;
          height: 49px;

          /* The label-container */
          .label-container {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            font-size: $fontSize + 2px;
            height: 49px;
            padding-left: 60px;
            margin-bottom: 12px;
            cursor: pointer;
            // font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
          }

          /* Hide the browser's default radio button */
          .label-container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }

          /* Create a custom radio button */
          .checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 49px;
            width: 49px;
            background-image: url('~@/assets/icons/both/game/testIcons/default.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            border-radius: 50%;
          }

          /* On mouse-over, add a grey background color */
          // .label-container:hover input ~ .checkmark {
          //     // background-color: #ccc;
          //     background-image: url("~@/assets/icons/both/game/testIcons/set.png");
          // }

          /* When the radio button is checked, add a blue background */
          .label-container input:checked ~ .checkmark {
            background-image: url('~@/assets/icons/both/game/testIcons/set.png');
          }
          // correct style
          .label-container input:checked ~ .checkmark.correct {
            background-image: url('~@/assets/icons/both/game/testIcons/correct.png');
          }
          // incorrect style
          .label-container input:checked ~ .checkmark.incorrect {
            background-image: url('~@/assets/icons/both/game/testIcons/incorrect.png');
          }

          /* Create the indicator (the dot/circle - hidden when not checked) */
          .checkmark:after {
            content: '';
            position: absolute;
            display: none;
          }

          /* Show the indicator (dot/circle) when checked */
          .label-container input:checked ~ .checkmark:after {
            display: block;
          }

          /* Style the indicator (dot/circle) */
          .label-container .checkmark:after {
            // top: 9px;
            // left: 9px;
            // width: 8px;
            // height: 8px;
            // border-radius: 50%;
            // background: white;
            visibility: hidden;
          }
        }
      }
    }

    .element-container-vertical {
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;

      .answer-container {
        height: 100%;
        padding-left: 60px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-start;
      }
    }
    .question-container-image {
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
    }
  }
  .main-image-container {
    position: relative;
    display: block;
    width: $elementWidth;
    height: $elementHeight;
    margin-bottom: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
